module.exports = __webpack_public_path__ + "img/Flag_of_Rwanda.1131af83.svg";